define('fukit/behavior/invoke.method.on.event.behavior',['require','exports','module','underscore','backbone','marionette','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Mn       = require('marionette'),
      Promise  = require('bluebird');

  var InvokeMethodOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      // This method is called at the beginning of the onEvent method.  If preventOnEventHandler
      //  returns true, the rest of onEvent doesn't run.
      // The default allows onEvent to run always.
      preventOnEventHandler: function() {
        return false;
      },
      // events: {
      //   "eventName": {
      //     method: null,
      //     methodTarget: null,
      //     methodArguments: null,
      //     useEventArguments: false,
      //     eventSource: null,
      //     model: null,
      //     resolveTargetModelFromEventArguments: false,
      //     onMethodSuccess: null,
      //     onMethodSuccessEvent: null,
      //     onMethodError: null,
      //     onMethodErrorEvent: null,
      //     showLoading: false
      //   },
      //   can be declared as a straight function
      //   "anotherEvent": function() {
      //   }
      // }
      events: null,

      // method that will be invoked
      // can be a function or a string
      // if used as a string, a methodTarget
      // must be provided
      method: null,

      // the context for which the method will be called with
      // the default is the behavior instance
      context: null,

      // the target that the method will be resolved from
      methodTarget: null,

      // use the configured model as the target of the method
      useModelAsTarget: false,

      // specify the arguments to be passed to the method
      methodArguments: null,

      // use the arguments from the event to pass to
      // the method
      useEventArguments: false,

      // listen to this view event
      eventName: 'press',

      // the source of the event
      eventSource: null,

      // when specified, this model will be used to trigger event on
      model: null,

      // when true, use first argument passed to event to resolve target model
      resolveTargetModelFromEventArguments: false,

      // function to execute when succesfully invoked method
      onMethodSuccess: null,

      // event to trigger when successfully invoked method
      onMethodSuccessEvent: null,

      // function to execute when failed to invoke method
      onMethodError: null,

      // event to trigger when failed to invoke method
      onMethodErrorEvent: null,
      showLoading: false,

      // when true, debounce method invocation
      debounce: false,
    },

    initialize: function() {
      this.bindEvent(this.getOption('eventName'), this.options);
      _.each(
        this.getOption('events'),
        function(options, eventName) {
          if (_.isFunction(options)) {
            options = { method: options };
          }
          this.bindEvent(eventName, options);
        },
        this
      );
    },

    bindEvent: function(eventName, options) {
      options || (options = {});
      var eventSource = Mn._getValue(options.eventSource, this) || this.view;
      this.listenTo(eventSource, eventName, function() {
        this.onEvent(options, _.toArray(arguments));
      });
    },

    onEvent: function(options, eventArgs) {
      var preventOnEventHandler = this.getOption('preventOnEventHandler');
      if (preventOnEventHandler.bind(this)()) {
        return;
      }
      options || (options = {});

      //prettier-ignore
      var model        = this.getTargetModel(options, eventArgs),
          methodTarget = options.useModelAsTarget ? model : Mn._getValue(options.methodTarget, this, [model]),
          args;

      if (options.methodArguments) {
        args = Mn._getValue(options.methodArguments, this, [model]);
      } else if (options.methodArgument) {
        args = [Mn._getValue(options.methodArgument, this, [model])];
      } else if (options.useEventArguments) {
        args = eventArgs;
      } else {
        args = [model];
      }

      if (options.debounce) {
        var self = this;
        var debouncedMethodInvocation = _.debounce(function() {
          self.invokeMethod(
            _.extend({}, options, {
              methodTarget: methodTarget,
              context: options.context || methodTarget || self,
              model: model,
              args: args,
            })
          );
        });
        debouncedMethodInvocation();
      } else {
        this.invokeMethod(
          _.extend({}, options, {
            methodTarget: methodTarget,
            context: options.context || methodTarget || this,
            model: model,
            args: args,
          })
        );
      }
    },

    getTargetModel: function(options, eventArgs) {
      options || (options = {});

      if (options.model || this.getOption('model')) {
        return options.model || this.getOption('model') || this.view.model;
      } else if (
        options.resolveTargetModelFromEventArguments ||
        this.getOption('resolveTargetModelFromEventArguments')
      ) {
        return _.find(eventArgs, function(arg) {
          return arg instanceof Backbone.Model;
        });
      } else {
        return this.view.model;
      }
    },

    invokeMethod: function(options) {
      options || (options = {});
      //prettier-ignore
      var self                 = this,
          onMethodSuccess      = options.onMethodSuccess,
          onMethodSuccessEvent = options.onMethodSuccessEvent,
          onMethodError        = options.onMethodError,
          onMethodErrorEvent   = options.onMethodErrorEvent,
          method               = options.method,
          methodTarget         = options.methodTarget,
          model                = options.model;

      if (options.showLoading) {
        this.view.loading = true;
      }

      return Promise.try(function() {
        if (_.isFunction(method)) {
          return method.apply(options.context ? options.context : self, options.args);
        } else if (methodTarget && _.isFunction(methodTarget[method])) {
          return methodTarget[method].apply(options.context, options.args);
        }
      })
        .then(function(resp) {
          if (onMethodSuccess) {
            onMethodSuccess.call(self, model, resp);
          }
          if (onMethodSuccessEvent) {
            self.view.trigger(onMethodSuccessEvent, model, resp);
          }
          return true;
        })
        .catch(function(e) {
          if (onMethodError) {
            onMethodError.call(self, model, e);
          }
          if (onMethodErrorEvent) {
            self.view.trigger(onMethodErrorEvent, model, e);
          }
          throw e;
        })
        .finally(function() {
          if (options.showLoading) {
            self.view.loading = false;
          }
        });
    },
  });

  module.exports = InvokeMethodOnEventBehavior;
});

